import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Collapse } from '@mui/material';

import useActiveLink from '../../../hooks/useActiveLink';
import { NavListProps } from '../types';

import NavItem from './NavItem';

// ----------------------------------------------------------------------

type NavListRootProps = {
  data: NavListProps;
  depth: number;
  hasChild: boolean;
};

export default function NavList({ data, depth, hasChild }: NavListRootProps) {
  const { pathname, search, hash } = useLocation();
  // children이 있을 경우에는 deep 인자값을 true로 설정하여 하위 path가 활성화되었을 활성화되도록 설정
  const { active, isExternalLink } = useActiveLink(data.path, hasChild ? true : false);
  const fullPath = `${pathname}${search}${hash}`;
  const hasActivePaths = data.activePaths
    ? data.activePaths.some((path) => path === fullPath)
    : false;

  const [open, setOpen] = useState(data.opened || active);

  useEffect(() => {
    // pathname이 변경되었을 때 open이 true이고 active가 false일 경우에는 handleClose 함수를 호출하여 open을 false로 설정
    if (!active && open) {
      handleClose();
    }
  }, [pathname]);

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <NavItem
        item={data}
        depth={depth}
        open={open}
        active={hasActivePaths || active}
        isExternalLink={isExternalLink}
        onClick={handleToggle}
      />

      {hasChild && (
        <Collapse in={open} unmountOnExit>
          <NavSubList data={data.children} depth={depth} />
        </Collapse>
      )}
    </>
  );
}

// ----------------------------------------------------------------------

type NavListSubProps = {
  data: NavListProps[];
  depth: number;
};

function NavSubList({ data, depth }: NavListSubProps) {
  return (
    <>
      {data.map((list) => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={depth + 1}
          hasChild={!!list.children}
        />
      ))}
    </>
  );
}
